// srt-tyres.js
import { VEHICLE_TYPE_RULES } from '../../common/srt/srt-common-presets.js';

export function updateTyreOptions(vt, unitIdx) {
   // function is called when vehicle type changes
   // sets allowable tyre configurations and defaults based on vehicle type
   const rule = VEHICLE_TYPE_RULES[vt];

   const $frontTyreType = $(`#f-tyre-config-${unitIdx}`);
   const $dualOption = $frontTyreType.find('option[value="Dual"]');
   const $rearTyreType = $(`#r-tyre-config-${unitIdx}`);
   const $rowOf8Option = $rearTyreType.find('option[value="Row of Eight"]');

   // Rule: Trucks cannot have dual tyres on the front axle (steer)
   const hideDualFront = vt === 'truck';
   $dualOption.toggle(!hideDualFront);

   // Rule: Show/hide "Row of Eight" option based on vehicle type rules
   const hideRowOf8 = rule.allowRowOfEight === false;
   $rowOf8Option.toggle(!hideRowOf8);

   // Set default tyre configurations based on vehicle type
   if (vt === 'truck') {
      $frontTyreType.val('Single');
      $rearTyreType.val('Dual');
   } else if (vt === 'low-loader') {
      $rearTyreType.val('Row of Eight');
   } else {
      // Other vehicle types use Dual tyres by default
      $frontTyreType.val('Dual');
      $rearTyreType.val('Dual');
   }
}
